import React, { useEffect, useState } from "react";
import { DashboardLayout, DeletePopupModal, PopupModal } from "../Components";
import AlertDeletePopupModal from "../Components/PopupModal/AlertDeletePopupModal";
import { MarketingNavbarComponent } from "../Components/navbar/marketingnav";
import { IoEyeOutline } from "react-icons/io5";
import { BiSearch } from "react-icons/bi";
import axiosConfig from "../Service/axiosConfig";
import { FormParser } from "../Components";
import Modal from "react-bootstrap/Modal";
import Masters from "../Components/masters.json";
import DataTable from "react-data-table-component";
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import { FaHandHoldingHeart } from "react-icons/fa";
import useDebouncedValue from "../Utils/Debounce";

const Queries = () => {
  const [search, SetSearch] = useState({
    search: "",
  });
  const debouncedSearchTerm = useDebouncedValue(search.search, 500);
  const HandleSearch = (e) => {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;
    console.log(name, value);
    SetSearch({ ...search, [name]: value });
  };
  const MastersModal = Masters.Contacts;
  const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("");
  const [Error, SetError] = useState("");
  const [deletePopupType, setDeletepopupType] = useState("");
  const [Data, SetData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [RowId, SetRowId] = useState();
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [RowPerPage, setRowPerPage] = useState(20);
  const [popupType, setpopupType] = useState("");
  const [show, setShow] = useState(false);
  const [modalTitle, setModalTitle] = useState("View Contact");
  const [message, setMessage] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    speciality: "",
    date: "",
    time: "",
  });

  const handleShow = () => {
    setShow(true);
    // setSelectedImage("")
    setFormData({
      first_name: "",
      last_name: "",
      email: "",
      mobile: "",
      comments: "",
    });
    setBlogid(null);
    setModalTitle("View Contact");
  };
  const handleClose = () => {
    setShow(false);
    // SetError("")
    setpopupType("");
  };
  const handleSort = (column, direction) => {
    axiosConfig
      .get(`/blogapp/query/?page=${currentPage}&page_size=${RowPerPage}&ordering=${direction === "asc" ? column.selector : -column.selector}`)
      .then((res) => SetData(res.data.results))
      .catch((error) => console.log(error));
    setCurrentPage(1);
  };
  const [passwordError, setPasswordError] = useState("");
  const formSubmit = (FormData, id) => {
    axiosConfig.defaults.headers["Content-Type"] = "multipart/form-data";
    if (FormData.id) {
      let newFormData = FormData;
      if (typeof FormData.image == "string") {
        delete newFormData.image;
      }
      axiosConfig
        .patch(`/blogapp/query/${FormData.id}/`, {
          ...FormData,
          image: FormData.image?.id,
        })
        .then(() => { setpopupType("success"); setPasswordError(""); GetData(); setShow(false); })
        .catch((error) => { setpopupType("error"); });
    } else {
      axiosConfig
        .post("/blogapp/query/", { ...FormData, image: FormData.image?.id })
        .then(() => { setpopupType("success"); setPasswordError(""); GetData(); setShow(false); })
        .catch((error) => { setpopupType("error"); });
    }
  };
  const GetData = async () => {
    setLoading(true);
    try {
      const responce = await axiosConfig.get(`/blogapp/query/?page=${currentPage}&page_size=${RowPerPage}`);
      SetData(responce.data.results);
      setLoading(false);
      setTotalRows(responce.data.count);
    } catch (error) {
      console.log(error);
    }
  };
  const tableCustomStyles = {
    rows: {
      style: {},
    },
    cells: {
      style: {
        justifyContent: "center",
      },
    },
    headCells: {
      style: {
        color: "#5C5C5C",
        justifyContent: "center",
        color: "rgb(33,37,41)",
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "28px",
      },
    },
  };
  useEffect(() => {
    const getSearchResults = async () => {
      axiosConfig
        .get(`/blogapp/query/?search=${debouncedSearchTerm}`)
        .then((res) => SetData(res.data.results))
        .catch((error) => console.log(error));
    };
    getSearchResults();
  }, [debouncedSearchTerm]);
  useEffect(() => {
    GetData();
  }, [currentPage, RowPerPage]);
  const [blogid, setBlogid] = useState();
  const contactEdit = (id) => {
    return axiosConfig
      .get(`/blogapp/query/${id}/`)
      .then((res) => {
        let form_data = res.data,
          formdata = {
            ...form_data,
          };
        setFormData(formdata);
        // setContactid(id);
      })
      .catch((error) => console.log(error));
  };
  const columns = [
    { name: "S.No", selector: "id", cell: (row, i) => (currentPage - 1) * RowPerPage + i + 1, sortable: true, reorder: true },
    { name: "Name", selector: "name", cell: (row) => row.name, sortable: true, reorder: true },
    { name: "Email", selector: "email", cell: (row) => row.email, sortable: true, reorder: true },
    { name: "Mobile", selector: "mobile", cell: (row) => row.mobile, sortable: true, reorder: true },
    { name: "Speciality", selector: "speciality", cell: (row) => row.speciality, sortable: true, reorder: true },
    { name: "Date", selector: "date", cell: (row) => row.date, sortable: true, reorder: true },
    { name: "Time", selector: "time", cell: (row) => row.time, sortable: true, reorder: true },
    { name: "ACTIONS", selector: (row) => { const HandleEdit = async () => { await contactEdit(row.id); setModalTitle("View Query"); setShow(true); }; return (<div className="row"><div className="col-4"><IoEyeOutline className="dashboard-tabe-data-actions" onClick={HandleEdit} /></div></div>); } },
  ];
  return (
    <>
      <div className="child-sidenav">
        <MarketingNavbarComponent />
        <div className="childnav-content">
          <div className="cat-button">
            {/* <div className="btn" onClick={handleShow} >
                            + Add New
                        </div> */}
          </div>
          <div className="col-4 input-cat-with-icon">
            <span className="icon-product">
              <BiSearch />
            </span>
            <input
              type="text"
              className="input-control"
              placeholder="Search"
              name="search"
              value={search.search}
              onChange={HandleSearch}
            />
          </div>
          <div className="table-responsive marginTop">
            <DataTable
              columns={columns}
              data={Data}
              pagination
              paginationTotalRows={totalRows}
              paginationPerPage={RowPerPage}
              paginationDefaultPage={currentPage}
              onChangePage={(page) => setCurrentPage(page)}
              paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
              paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
              onChangeRowsPerPage={(RowsPerPageChange) =>
                setRowPerPage(RowsPerPageChange)
              }
              onSort={handleSort}
              paginationServer
              fixedHeader
              subHeader
              customStyles={tableCustomStyles}
              progressPending={loading}
              progressComponent={
                <div className="loader-container">
                  <img
                    src={require("../Components/FormParser/images/loader2.gif")}
                    alt="Loading..."
                  />
                </div>
              }
            />
          </div>
          <div>
            <Modal
              size="xl"
              show={show}
              onHide={handleClose}
              aria-labelledby="example-modal-sizes-title-lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  {modalTitle}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {passwordError && (
                  <div className="alert alert-danger" role="alert">
                    {passwordError}
                  </div>
                )}

                <FormParser
                  modelObject={MastersModal}
                  formData={formData}
                  formSubmit={formSubmit}
                  error={Error}
                  readOnly={true}
                />
              </Modal.Body>
            </Modal>
            {popupType !== "" && (
              <PopupModal
                setpopupType={setpopupType}
                popupType={popupType}
                Navigation=""
                Message={message}
              />
            )}
            {deletePopupType !== "" && (
              <DeletePopupModal
                setDeletepopupType={setDeletepopupType}
                deletePopupType={deletePopupType}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export { Queries };